export const wh_statuses = [
    { value: 'Any', label: 'Any' },
    { value: 'Received', label: 'Received' },
    { value: 'Not Received', label: 'Not Received' },
];

export const owner_options = [
    { value: 'All', label: 'All' },
    { value: 'Internal', label: 'Internal' },
    { value: 'Onward', label: 'Onward' },
];
